import API from "./apiConfig"

export const getChartData = (projectId, payload = null) => {
  return API
    .get(`/projects/${projectId}/borehole_depth_chart.json`, { params: payload })
    .then(res => res.data)
}
